import React from 'react';
import classnames from 'classnames';
import { List } from 'tea-component';
import GameImage from '@/pages/home/components/GameImage';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { ENTITY_TYPE_NAMES_MAP } from './constants';

import type { IBaseProps } from '@intelligence/types/common';
import type { ITrendingGame, ITrendingGameEntityTypeData } from '../../types';

interface IItemBoxProps extends IBaseProps {
  keyword: string;
  data: ITrendingGameEntityTypeData;
  value: string;
  onClick: (payload: ITrendingGame) => void;
}

const ItemBox: React.FC<IItemBoxProps> = (porps) => {
  const { keyword, data, value, onClick, selectedUidAndId } = porps;

  const { formatMessage } = useIntlExtend();

  const type = data?.type || '';
  const typeNameLocaleKey = ENTITY_TYPE_NAMES_MAP[type];

  return (
    <>
      <List.GroupLabel className="dbi-trending-overlay-label">
        {formatMessage({ id: typeNameLocaleKey })}
      </List.GroupLabel>
      {data?.options?.map((option, index) => (
        <List.Item
          key={index}
          selected={
            selectedUidAndId
              ? selectedUidAndId === option?.unified_id + option?.id
              : value === option?.unified_id
          }
          onClick={() => {
            onClick(option);
          }}
        >
          <div className="dbi-trending-overlay-flex">
            <GameImage
              entityType={option?.type === 'mobile' ? 'mobile' : 'pc'}
              src={option?.cover}
              className={classnames('dbi-trending-overlay-img', {
                pc: type === PC_CONSOLE_COMBINE_ENTITY_TYPE,
              })}
            />
            <div className="dbi-trending-overlay-text">
              {getTextWithHighlight(option?.name, keyword)}
            </div>
          </div>
        </List.Item>
      ))}
    </>
  );
};

export default ItemBox;
